var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"nav"},[_vm._m(0),_c('div',{staticClass:"nav-title"},[_c('router-link',{attrs:{"to":_vm.goTo}},[_vm._v(" إحصائات وأرقام ")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-logo"},[_c('img',{attrs:{"height":"200","width":"200","src":require("../../../../../public/assets/images/website/website-svgs/rehab-alhabeb/rehab-white.svg"),"alt":"logo"}})])
}]

export { render, staticRenderFns }